<script>
  import DatePicker from './Flatpickr/DatePicker.svelte';
</script>

<!-- Modal -->
<div
  class="modal fade"
  id="reasonsModal"
  tabindex="-1"
  aria-labelledby="reasonsModal"
  aria-hidden="true"
>
  <div class="modal-dialog shadow">
    <div class="modal-content">
      <div class="modal-header">
        <h5
          class="modal-title font-size-14"
          id="exampleModalLabel"
        >
          Notes/Reasons (Optional)
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group mb-3">
              <label
                for=""
                class="form-label">Completion Date</label
              >
              <DatePicker style="active select-border" />
            </div>
          </div>
          <div class="col-md-6">
            <button class="btn btn btn-reset font-size-12 color-red bg-transparent">Reset</button>
          </div>
          <div class="col-md-12">
            <div class="form-group mb-3">
              <label
                for=""
                class="form-label">Please tell us why are you making this change</label
              >
              <textarea
                class="form-control"
                name="example-text-input"
                placeholder="Please tell us why are you making this change"
                rows="6"
              ></textarea>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="trans-btn my-0 mx-3 px-4 font-size-12 outline-0 btn-cancel font-size-12"
          data-bs-dismiss="modal">Cancel</button
        >
        <button
          type="button"
          class="btn btn-primary m-0 px-4 font-size-12">Done</button
        >
      </div>
    </div>
  </div>
</div>

<style lang="scss">
  .shadow {
    box-shadow: 0 0 30px 0 rgba(82, 63, 105, 0.05);
  }
  .btn-reset {
    margin-top: 28px;
    margin-left: -26px;
  }
</style>
